import { useState, useEffect } from 'react';
import InputValidation from '../../utils/InputValidation';

const useValidateFields = (
  {
    firstName,
    lastName,
    phone,
    email,
    companyName,
    companyPhone,
    address,
    password,
    passwordConfirm,
  },
  selectedItem
) => {
  const [validState, setValidState] = useState({
    firstNameValid: '',
    lastNameValid: '',
    phoneValid: '',
    emailValid: '',
    companyNameValid: '',
    companyPhoneValid: '',
    addressValid: '',
    passwordValid: '',
    passwordConfirmValid: '',
  });

  const validatePassword = (password) => {
    if (selectedItem) {
      return !password ? '' : InputValidation.validateUserPassword(password);
    } else {
      return InputValidation.validateEmpty(password, 'Password') === ''
        ? InputValidation.validateUserPassword(password)
        : InputValidation.validateEmpty(password, 'Password');
    }
  };

  useEffect(() => {
    const newValidState = {
      firstNameValid: firstName !== undefined ? InputValidation.validateFirstName(firstName) : '',
      lastNameValid: lastName !== undefined ? InputValidation.validateNameLength(lastName) : '',
      phoneValid: phone !== undefined ? InputValidation.validatePhone(phone) : '',
      emailValid: email !== undefined ? InputValidation.validateUserEmail(email) : '',
      companyNameValid: companyName !== undefined ? InputValidation.validateNameLength(companyName) : '',
      companyPhoneValid: companyPhone !== undefined ? InputValidation.validatePhone(companyPhone) : '',
      addressValid: address !== undefined ? InputValidation.validateAddress(address) : '',
      passwordValid: password !== undefined ? validatePassword(password) : '',
      passwordConfirmValid: passwordConfirm !== undefined ? InputValidation.validatePasswordConfirm(password, passwordConfirm) : '',
    };

    setValidState(newValidState);
  }, [
    firstName,
    lastName,
    phone,
    email,
    companyName,
    companyPhone,
    address,
    password,
    passwordConfirm,
    selectedItem,
  ]);

  return validState;
};

export default useValidateFields;
